import { COMMUTE_TYPES_MAP } from '../interfaces/villages';
import { ECommuteDistanceType } from '../types/filters';

export const generateDistanceLabel = (type: ECommuteDistanceType = ECommuteDistanceType.Road, regionId?: number) => {
  if (type === ECommuteDistanceType.Station) {
    return 'до ж/д вокзала';
  }

  const commuteType = regionId !== undefined ? COMMUTE_TYPES_MAP[regionId] : undefined;
  const targetText = commuteType || 'центра';

  return `до ${targetText}`;
};
